import FilterTextField from '../baseInputTypes/FilterTextField'

export const FeatureCode = () => {
  return (
    <FilterTextField
      label="Feature Code"
      fieldPath={'productInformation.featureCode'}
    />
  )
}
